import type { SVGProps } from "react";

function FacebookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      height="22.004"
      viewBox="0 0 11.785 22.004"
      width="11.785"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>{".a{fill:#fff;}"}</style>
      </defs>
      <path
        className="a"
        d="M12.622,12.377l.611-3.982H9.412V5.811a1.991,1.991,0,0,1,2.245-2.151h1.737V.269A21.183,21.183,0,0,0,10.311,0c-3.147,0-5.2,1.907-5.2,5.36V8.395h-3.5v3.982h3.5V22h4.3V12.377Z"
        transform="translate(-1.609)"
      />
    </svg>
  );
}

export default FacebookIcon;
